module.exports = __webpack_public_path__ + "img/search_comm_icon@2x.3970987b.png";